module.exports = __webpack_public_path__ + "img/signature-solid.2194e4fb.svg";